module.exports = __webpack_public_path__ + "static/images/e4f28eab6e91ecc61eefc4262a859b78.svg";